export const oauth2Setting = {
  clientId: 'user_client',
  clientSecret: 'user',
};

export enum Oauth2GrantType {
  passwordType = 'password',
  refreshTokenType = 'refresh_token',
}
